module.exports = [
  ...require('./_magicItemRawList_DMG_d'),
  require('./decanter_of_endless_water'),
  require('./deck_of_many_things'),
]
